import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldEventInvite']),
        getByEvent: state => event => 
          {
            return state.objs.filter(e => e.event === event);
          },
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldEventInvite'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldEventInvite'])
    },
}